import request from "../utils/request";


const resourceApi = {
  Medicine: "/medicine",
}

export function getMedicineListApi(parameter) {
  return request({
    url: resourceApi.Medicine,
    method: "get",
    params: parameter,
  })
}
export function editMedicineApi(parameter) {
  return request({
    url: resourceApi.Medicine,
    method: "patch",
    data: parameter,

  })
}
export function deleteMedicineApi(medicine_id) {
  return request({
    url: resourceApi.Medicine + '/' + medicine_id,
    method: "delete",

  })
}
export function addMedicineApi(parameter) {
  return request({
    url: resourceApi.Medicine,
    method: "post",
    data: parameter,

  })
}
